export const MANAGE_PROFILE_CONTEXT = '/digital-receipts/managedcp/';
export const NOT_MY_RECEIPT_CONTEXT = '/digital-receipts/notmyreceipt/';
export const RE_ENABLE_PROFILE_CONTEXT = '/digital-receipts/activatedcp/';

export {};
